import type { RiksjaEnv } from '@riksja/common/types'

export const getRiksjaEnvironment = (): RiksjaEnv => {
  switch (process.env.NEXT_PUBLIC_RIKSJA_WEB_ENV) {
    case 'dev':
      return 'dev'
    case 'acc':
      return 'acc'
    case 'staging':
      return 'staging'
    case 'prod':
      return 'prod'
    default:
      throw new Error('Invalid environment: ' + process.env.NEXT_PUBLIC_RIKSJA_WEB_ENV)
  }
}

// Datadog's `env` tag uses the conventional full name `production`; our internal
// RiksjaEnv stays `prod`. Map only at the Datadog boundary (OTEL spans + browser
// RUM) so the emitted `env` tag matches the backend and the monitors/SLOs/
// dashboards (infra/datadog-org). Keep the short `prod` value everywhere else —
// env-keyed lookups (apiUrlForEnv, FE base url) rely on it.
export const toDatadogEnv = (env: string): string => (env === 'prod' ? 'production' : env)
